<template>
  <vs-popup
    :title="$t('ForwardMessage')"
    :active="active"
    @update:active="updateActive"
  >
    <div class="forward-messages-chat-list mb-4">
        <vs-input
          ref="input"
          size="lg"
          class="w-full rounded-lg1 br-6"
          :placeholder="$t('Search') + `...`"
          icon-pack="feather"
          icon="icon-search"
          icon-no-border
          v-model="searchChat"
        />
    </div>
    <div v-if="chatUserList.length" class="chat__chats-list mb-4 px-4 br-20">   
      <h4 class="chat-contact-header d-block text-primary text-xl font-weight-medium">
          {{ $t("Chats") }}
      </h4>  
      <ul class="mt-1 chat__active-chats bordered-items">
        <li
          class="cursor-pointer flex"
          v-for="(contact, index) in chatUserList"
          :track-by="contact.id"
          :key="index"
        >
          <b-form-checkbox
              class="mt-5"
              :id="'chat-'+ contact.id"
              :value="contact"
              :name="'chat-'+ contact.id"
              v-model="selectedChats"
          >
          </b-form-checkbox>
          <contact-data
            :contact="contact"
            :color="contact.color"
          ></contact-data>
        </li>
      </ul>
    </div>
    <div v-if="teamUserList.length" class="chat__chats-list mb-4 px-4 br-20">     
      <h4 class="chat-contact-header d-block text-primary text-xl font-weight-medium">
          {{ $t("Teams") }}
      </h4>  
      <ul class="mt-1 chat__active-chats bordered-items">
        <li
          class="cursor-pointer flex"
          v-for="(contact, index) in teamUserList"
          :track-by="contact.id"
          :key="index"
        >
          <b-form-checkbox
              class="mt-5"
              :id="'chat-'+ contact.id"
              :value="contact"
              :name="'chat-'+ contact.id"
              v-model="selectedChats"
          >
          </b-form-checkbox>
          <contact-data
            :contact="contact"
            :color="contact.color"
          ></contact-data>
        </li>
      </ul>
    </div>
    <div  v-if="clientUserList.length" class="chat__chats-list mb-4 px-4 br-20"> 
       <h4 class="chat-contact-header d-block text-primary text-xl font-weight-medium">
          {{ $t("Clients") }}
      </h4>    
      <ul class="mt-1 chat__active-chats bordered-items">
        <li
          class="cursor-pointer flex"
          v-for="(contact, index) in clientUserList"
          :track-by="contact.id"
          :key="index"
        >
          <b-form-checkbox
              class="mt-5"
              :id="'chat-'+ contact.id"
              :value="contact"
              :name="'chat-'+ contact.id"
              v-model="selectedChats"
          >
          </b-form-checkbox>
          <contact-data
            :contact="contact"
            :color="contact.color"
          ></contact-data>
        </li>
      </ul>
    </div>
    <div v-if="selectedChatsCount > 0" class="chat__input selected-chats flex bg-white mt-1 p-3 mb-8"
      style="position: fixed;bottom: 0;z-index: 100;"
      :style="setWidth">
      <div class="flex-1 flex">
        <div class="ml-1 mt-1"> {{selectedChatsCount}} {{ $t('Selected') }}</div>
      </div>
        <feather-icon
          style="cursor: pointer"
          svgClasses="w-6 h-6 hover:text-danger stroke-current"
          icon="SendIcon"
          @click="forwardSelectedChats"
        />
    </div>       
  </vs-popup>
</template>

<style>
.forward-messages-chat-list .vs-input--input.hasIcon:not(.icon-after-input) + .vs-input--placeholder {
    padding-left: 2rem !important;
    margin: 5px;
}

.online-dot {
    position: relative;
    top: -10px;
    right: 1px;
}
</style>

<script>
import ContactData from "@/components/ContactData.vue";
import $ from "jquery";

export default {
  components: {
    ContactData,
  },
  props: {
    active: { type: Boolean, required: true },
    chatList: { type: Array },
    teamList: { type: Array },
    clientList: { type: Array, 
      default() {
            return []
        }
    },
  },
  data() {
    return {
      chatUnseenMessages: 0,
      selectedChats: [],
      searchChat: '',
      setWidth: {
        width: '547px'
      }
    };
  },
  computed: {
    windowWidth() {
      var new_width = $('.vs-popup').width();
      this.setWidth = {
        width: (new_width - 53) + 'px'
      }
    },
    selectedChatsCount() {
      var new_width = $('.vs-popup').width();
      this.setWidth = {
        width: (new_width - 53) + 'px'
      }
      return this.selectedChats.length;
    },
    chatUserList() {
      const search = this.searchChat ? this.searchChat.toLowerCase() : null;
      return this.chatList.filter((contact) =>
            search == null ||
            (contact && ((contact.display_name && contact.display_name.toLowerCase().includes(search) 
              || contact.fullName && contact.fullName.toLowerCase().includes(search))))
        );
    },
    teamUserList() {
      const search = this.searchChat ? this.searchChat.toLowerCase() : null;
      return this.teamList.filter((contact) =>
            search == null ||
            (contact && contact.fullName && contact.fullName.toLowerCase().includes(search))
        );
    },
    clientUserList() {
      const search = this.searchChat ? this.searchChat.toLowerCase() : null;
      return this.clientList.filter((contact) =>
            search == null ||
            (contact && contact.fullName && contact.fullName.toLowerCase().includes(search))
        );
    }
  },
  methods: {
    updateActive(active) {
      this.$emit("update:active", active);
    },
    forwardSelectedChats() {
      const payload = {
        chat_head_ids: [],
        staff_ids: [],
        client_ids: []
      }
      payload.chat_head_ids = this.selectedChats.filter(chat => !chat.is_contact).map(chat => chat.id);
      payload.staff_ids = this.selectedChats.filter(chat => chat.is_contact && chat.user_role=='staff').map(chat => chat.id);
      payload.client_ids = this.selectedChats.filter(chat => chat.is_contact && chat.user_role=='user').map(chat => chat.id);
      this.$emit('forwardMsg', payload);
      this.selectedChats = [];
      this.searchChat = '';
    },
  },
};
</script>
